import { ActionAfterViewObserver } from '@cian/action-after-viewed-component';
import * as React from 'react';
import { useSelector } from 'react-redux';

import { NewbuildingBlackFridayBanner } from '../../components/NewbuildingBlackFridayBanner';
import { getNewbuildingBlackFridayUrl } from '../../selectors/newbuildingBlackFriday';
import { trackBannerClick, trackBannerShow } from './tracking';

export function NewbuildingBlackFridayBannerContainer() {
  const url = useSelector(getNewbuildingBlackFridayUrl);

  return (
    <ActionAfterViewObserver callback={trackBannerShow} triggerOnce>
      <NewbuildingBlackFridayBanner url={url} onClick={trackBannerClick} />
    </ActionAfterViewObserver>
  );
}
